module.exports = __webpack_public_path__ + "fonts/bcf26ee16fc1869f61cb5d0048d83f09.svg";